export const login = {
    "sendCode": {
      "title": "Restablecer cuenta",
      "description": "Introduce tu correo electrónico o número de teléfono a continuación y le enviaremos un mensaje para restablecer tu cuenta."
    },
    "changePassword": {
      "description": "Hemos enviado un código de restablecimiento de contraseña por correo electrónico. Introdúzcalo a continuación para restablecer su contraseña.",
      "descriptiopn2": "Para continuar, actualiza tu contraseña"
    },
    "confirm": {
      "title": "¡Bienvenido de nuevo!",
      "description": "Por favor, ingrese a su cuenta"
    },
    "signin": {
      "title": "Bienvenido",
      "description": "Ingrese las credenciales para acceder al portal web",
      "button": "Iniciar",
      "footer": "Problemas para iniciar sesión",
      "footerConfirm": "Volver al inicio de sesión",
      "ressetPassword": "Restablecer contraseña",
      "changePassword": "Cambiar contraseña",
      "confirm": "Validar código",
      "form": {
        "email": "Nombre de usuario",
        "username": "Correo electrónico o Teléfono",
        "password": "Contraseña",
        "newPassword": "Nueva contraseña",
        "confirmPassword": "Confirmar contraseña",
        "check": "recordarme en este dispositivos",
        "code": "Código de validación",
        "currentPassword": "Contraseña actual"
      }
    }
  }